import { render } from "./BlockTextTwoColumn.vue?vue&type=template&id=841675d4&lang=pug"
import script from "./BlockTextTwoColumn.vue?vue&type=script&lang=js"
export * from "./BlockTextTwoColumn.vue?vue&type=script&lang=js"

import "./BlockTextTwoColumn.vue?vue&type=style&index=0&id=841675d4&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__